import { Tooltip } from 'antd';
import { ReactNode } from 'react';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';

interface FormTooltipProps {
  title: string;
  description: string;
  children?: ReactNode;
}

function FormTooltip({ children, title, description }: FormTooltipProps) {
  const tooltipTitle = () => {
    if (title && description) {
      return (
        <Flex direction="column">
          {/* @ts-expect-error */}
          <Text size="18px" color={color.highempahis} mb="10px">
            {title}
          </Text>
          <Text color={color.dimgray}>{description}</Text>
        </Flex>
      );
    }

    return null;
  };

  const additionalProps = !title && !description ? { visible: false } : {};

  return (
    <Tooltip
      trigger={['focus']}
      title={tooltipTitle}
      placement="leftTop"
      color="white"
      overlayInnerStyle={{
        color: 'black',
        padding: '15px',
        width: '220px',
      }}
      {...additionalProps}
    >
      {children}
    </Tooltip>
  );
}

export default FormTooltip;
